export default "__VITE_ASSET__95bebf70__"